import React from 'react';
import { includes } from 'lodash';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Panel from '../../../../../components/outline/Panel';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import BaseForm from '../../../../../components/form/BaseForm';
import InputForm from '../../../../../components/form/InputForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { setPhoneFormat, setNumberWithComma, setDash } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import OpenOrderReturnItemDetail from '../../../../../components/link/OpenOrderReturnItemDetail';
import InfoTable from '../../../../../components/table/InfoTable';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenReturnExchangeAttachment from '../../../../../containers/app/common/OpenReturnExchangeAttachment';
import { AMONDZ_MEMBER_TYPE } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_RETURN_BUYER_RESPONSIBILITY_MANAGER,
  ORDER_RETURN_BUYER_RESPONSIBILITY_TYPE_LIST,
  ORDER_RETURN_SELLER_RESPONSIBILITY_MANAGER,
  ORDER_RETURN_TYPE_TEXT,
  MAXIMUM_NUMBER_OF_ORDER_RETURN_ADMIN_MEMO_TEXT,
  PAY_METHOD_TYPE,
  PAY_METHOD_TYPE_TEXT,
  MAXIMUM_NUMBER_OF_ORDER_RETURN_REFUND_COMPLETE_REASON_TEXT,
  ORDER_RETURN_STATUS,
  ORDER_ITEM_STATUS_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
  ORDER_RETURN_STATUS_TEXT,
  ORDER_CANCEL_STATUS_TEXT,
  ORDER_RETURN_ACTUAL_AMOUNT_ERROR_PLUS_RANGE,
} from '../../../../../constants/service/app/orderConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './OrderReturnDetail.scss';

const OrderReturnDetail = (props) => {
  const { form, onChangeRefundActualAmount, orderReturnDetail, setData } = props;

  // 예상고객부담금
  const expectCustomerCharge =
    orderReturnDetail.totalPrice - orderReturnDetail.returnDeliveryFee < 0
      ? orderReturnDetail.returnDeliveryFee - orderReturnDetail.totalPrice
      : 0;
  // 판매자가 측정한 환불 금액 - 고객부담금
  const customerCharge =
    orderReturnDetail.totalPrice - orderReturnDetail.returnDeliveryFee < 0
      ? orderReturnDetail.returnDeliveryFee - orderReturnDetail.totalPrice + orderReturnDetail.refundSellerAmount
      : 0;
  // 고객 예상 환불 금액
  const expectCustomerRefund =
    orderReturnDetail.totalPrice - orderReturnDetail.returnDeliveryFee + expectCustomerCharge;

  return (
    <div className="order-return-detail">
      {/*반품되는 주문서 정보*/}
      <Panel>
        <div className="panel-header">
          <div className="title">반품 정보</div>
        </div>

        <div className="panel-body">
          {/*주문번호*/}
          <BaseForm label="주문번호" content={orderReturnDetail.orderId} />

          {/*상품 주문번호*/}
          <BaseForm
            label="상품 주문번호"
            content={
              <OpenOrderItemDetail text={orderReturnDetail.orderItemId} orderItemId={orderReturnDetail.orderItemId} />
            }
          />

          {/*상품번호*/}
          <BaseForm
            label="상품번호"
            content={<OpenProductDetail text={orderReturnDetail.productId} productId={orderReturnDetail.productId} />}
          />

          {/*상품명*/}
          <BaseForm
            label="상품명"
            content={
              <OpenPreviewProductDetail text={orderReturnDetail.productName} productId={orderReturnDetail.productId} />
            }
          />

          {/*반품 책임*/}
          <BaseForm
            label="반품 책임"
            content={
              includes(ORDER_RETURN_BUYER_RESPONSIBILITY_TYPE_LIST, orderReturnDetail.returnType)
                ? ORDER_RETURN_BUYER_RESPONSIBILITY_MANAGER
                : ORDER_RETURN_SELLER_RESPONSIBILITY_MANAGER
            }
          />

          {/*반품 사유*/}
          <BaseForm
            label="반품 사유"
            content={
              <OpenReturnExchangeAttachment
                title={'반품사유'}
                orderReturnExchangeId={orderReturnDetail.orderReturnId}
                type={RETURN_EXCHANGE_REASON_TYPE.RETURN_REQUEST}
                text={ORDER_RETURN_TYPE_TEXT[orderReturnDetail.returnType]}
                reason={orderReturnDetail.returnReason}
              />
            }
          />

          {/*반품 상세 사유*/}
          <BaseForm label="반품 상세 사유" content={orderReturnDetail.returnReason} />
        </div>
      </Panel>

      {/*연관된 상품 주문 정보*/}
      {/*단일 주문 상품이면 영역을 보여주지않는다.*/}
      {orderReturnDetail.associateOrderInfoList.length > 0 ? (
        <Panel>
          <div className="panel-header">
            <div className="title">연관된 상품 주문</div>
          </div>

          <div className="panel-body">
            <div className="associate-order-item-info-table">
              <InfoTable className="associate-order-item-info" scroll={{ x: true }}>
                <thead>
                  <tr>
                    <th>연관된 상품 주문 반품 번호</th>
                    <th>연관된 상품 주문 번호</th>
                    <th>브랜드명</th>
                    <th>상품 주문 상태</th>
                    <th>할당된 결제 금액</th>
                    <th>엮인 환불금액</th>
                  </tr>
                </thead>
                <tbody>
                  {orderReturnDetail.associateOrderInfoList.map((item) => (
                    <tr key={item.orderItemId}>
                      <td className="tc">
                        {
                          /**
                           *  반품 승인, 반품 완료 일 경우에만
                           *  새로운 탭에서 반품 상세 페이지를 여는 anchor 노출
                           */
                          item.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE ||
                          item.orderReturnStatus === ORDER_RETURN_STATUS.REFUND_DONE ? (
                            <OpenOrderReturnItemDetail text={item.orderReturnId} orderItemId={item.orderItemId} />
                          ) : (
                            setDash(item.orderReturnId)
                          )
                        }
                      </td>
                      <td className="tc">
                        <OpenOrderItemDetail text={item.orderItemId} orderItemId={item.orderItemId} />
                      </td>
                      <td className="tc">{item.brandName}</td>
                      {item.orderReturnStatus ? (
                        <td className="tc">{`${ORDER_ITEM_STATUS_TEXT[item.orderItemStatus]}(${
                          ORDER_RETURN_STATUS_TEXT[item.orderReturnStatus]
                        })`}</td>
                      ) : item.orderCancelStatus ? (
                        <td className="tc">{`${ORDER_ITEM_STATUS_TEXT[item.orderItemStatus]}(${
                          ORDER_CANCEL_STATUS_TEXT[item.orderCancelStatus]
                        })`}</td>
                      ) : (
                        <td className="tc">{ORDER_ITEM_STATUS_TEXT[item.orderItemStatus]}</td>
                      )}
                      <td className="tc">{setNumberWithComma(item.totalPrice, '원')}</td>
                      <td className="tc">{setNumberWithComma(item.refundActualAmount, '원')}</td>
                    </tr>
                  ))}
                </tbody>
              </InfoTable>
            </div>
          </div>
        </Panel>
      ) : null}

      {/*고객이 반품 요청시 계산된 고객이 받을 환불 예상 금액*/}
      <Panel>
        <div className="panel-header">
          <div className="title">고객 예상 환불 금액</div>
        </div>

        <div className="panel-body">
          {/*구매자 ID*/}
          <BaseForm
            label="구매자 ID"
            content={<OpenUserDetail text={orderReturnDetail.buyerAccount} userId={orderReturnDetail.userId} />}
          />

          {/*구매자명*/}
          <BaseForm label="구매자명" content={orderReturnDetail.buyerName} />

          {/*구매자 연락처*/}
          <BaseForm
            label="구매자 연락처"
            content={
              <SendMessageService
                text={setPhoneFormat(orderReturnDetail.buyerPhone)}
                memberType={AMONDZ_MEMBER_TYPE.USER}
                targetId={orderReturnDetail.userId}
              />
            }
          />

          {/*고객 결제 금액*/}
          <BaseForm label="고객 결제 금액" content={setNumberWithComma(orderReturnDetail.totalPrice, '원')} />

          {/*고객 부담 최초무료배송비*/}
          <BaseForm
            label="고객 부담 최초무료배송비"
            content={setNumberWithComma(orderReturnDetail.returnDeliveryFee, '원')}
          />

          {/*예상고객부담금 (결제금액 - 최초무료배송비 가 음수인 경우에만 발생한다.)*/}
          <BaseForm
            label="예상고객부담금"
            content={setNumberWithComma(expectCustomerCharge, '원')}
            subContent={
              <div>
                <div className="sub-info">** 최초무료배송비가 고객결제금액을 초과할 경우, 발생</div>
                <div className="sub-price-info">[최초무료배송비 - 고객결제금액]</div>
              </div>
            }
          />

          {/*고객 예상 환불 금액 (결제금액 - 최초무료배송비 가 음수인 경우에는 예상고객부담금을 더해주어야한다.)*/}
          <BaseForm
            className="emphasize"
            label="고객 예상 환불 금액"
            content={setNumberWithComma(expectCustomerRefund, '원')}
            subContent={<div className="sub-price-info">[고객 결제 금액 - 최초무료배송비 + 예상고객부담금]</div>}
          />
        </div>
      </Panel>

      {/*판매자가 계산한 고객이 받을 환불 예상 금액*/}
      <Panel>
        <div className="panel-header">
          <div className="title">판매자가 측정한 환불 금액</div>
        </div>

        <div className="panel-body">
          {/*브랜드명*/}
          <BaseForm
            label="브랜드명"
            content={
              <OpenBrandDetail
                text={`${orderReturnDetail.storeName}(${orderReturnDetail.storeId})`}
                storeId={orderReturnDetail.storeId}
              />
            }
          />

          {/*브랜드 연락처*/}
          <BaseForm label="브랜드 연락처" content={setPhoneFormat(orderReturnDetail.storePhone)} />

          {/*판매자명*/}
          <BaseForm label="판매자명" content={`${orderReturnDetail.sellerName}(${orderReturnDetail.sellerId})`} />

          {/*판매자 연락처*/}
          <BaseForm
            label="판매자 연락처"
            content={
              <SendMessageService
                text={setPhoneFormat(orderReturnDetail.sellerPhone)}
                memberType={AMONDZ_MEMBER_TYPE.SELLER}
                targetId={orderReturnDetail.storeId}
              />
            }
          />

          {/*고객 결제 금액*/}
          <BaseForm label="고객 결제 금액" content={setNumberWithComma(orderReturnDetail.totalPrice, '원')} />

          {/*고객 부담 최초무료배송비*/}
          <BaseForm
            label="고객 부담 최초무료배송비"
            content={setNumberWithComma(orderReturnDetail.returnDeliveryFee, '원')}
          />

          {/*예상고객부담금 (결제금액 - 최초무료배송비 가 음수인 경우에만 발생한다.)*/}
          <BaseForm
            label="예상고객부담금"
            content={setNumberWithComma(expectCustomerCharge, '원')}
            subContent={
              <div>
                <div className="sub-info">** 최초무료배송비가 고객결제금액을 초과할 경우, 발생</div>
                <div className="sub-price-info">[최초무료배송비 - 고객결제금액]</div>
              </div>
            }
          />

          {/*고객 예상 환불 금액*/}
          <BaseForm
            className="emphasize"
            label="고객 예상 환불 금액"
            content={setNumberWithComma(expectCustomerRefund, '원')}
            subContent={<div className="sub-price-info">[고객 결제 금액 - 최초무료배송비 + 예상고객부담금]</div>}
          />

          {/*판매자 추가 청구 비용*/}
          <BaseForm
            label="판매자 추가 청구 비용"
            content={setNumberWithComma(orderReturnDetail.refundExtraFee, '원')}
          />

          {/*고객부담금 (결제금액 - 최초무료배송비 가 음수인 경우에만 발생한다.)*/}
          <BaseForm
            label="고객부담금"
            content={setNumberWithComma(customerCharge, '원')}
            subContent={
              <div>
                <div className="sub-info">** 최초무료배송비가 고객결제금액을 초과할 경우, 발생</div>
                <div className="sub-price-info">[최초무료배송비 - 고객결제금액 + 판매자 설정 환불금액]</div>
              </div>
            }
          />

          {/*추가 청구 비용 책정 사유*/}
          <BaseForm label="추가 청구 비용 책정 사유" content={orderReturnDetail.returnCompleteReason} />

          {/*판매자 설정 환불금액*/}
          <BaseForm
            className="emphasize"
            label="판매자 설정 환불금액"
            content={setNumberWithComma(orderReturnDetail.refundSellerAmount, '원')}
          />
        </div>
      </Panel>

      {/*관리자가 계산한 구매자가 받을 환불 예상 금액*/}
      <Panel>
        <div className="panel-header">
          <div className="title">최종 환불 금액</div>
        </div>

        <div className="panel-body">
          {/*고객 결제 금액*/}
          <BaseForm label="고객 결제 금액" content={setNumberWithComma(orderReturnDetail.totalPrice, '원')} />

          {/*판매자 측정 환불 금액*/}
          <BaseForm
            label="판매자 측정 환불 금액"
            content={setNumberWithComma(orderReturnDetail.refundSellerAmount, '원')}
          />

          {/*판매자 부담 추가 배송비(도서산간)*/}
          <BaseForm
            label="판매자 부담 추가 배송비(도서산간)"
            content={setNumberWithComma(orderReturnDetail.sellerDeliveryExtraFee, '원')}
          />

          {/*예상 최종 환불 금액*/}
          <BaseForm
            label="예상 최종 환불 금액"
            content={setNumberWithComma(
              orderReturnDetail.refundSellerAmount + orderReturnDetail.sellerDeliveryExtraFee,
              '원',
            )}
            subContent={<div className="sub-price-info">[판매자 측정 환불 금액 + 판매자 부담 추가 배송비]</div>}
          />

          {/*최종 환불 금액*/}
          {/*포인트 가중치때문에 1원이 남는 경우때문에 상한선을 결제금액 + 5원으로 해놨다.*/}
          <InputForm
            label="최종 환불 금액"
            type="number"
            form={form}
            style={{ width: 200 }}
            isEditable={orderReturnDetail.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE}
            rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
            min={0}
            max={orderReturnDetail.totalPrice + ORDER_RETURN_ACTUAL_AMOUNT_ERROR_PLUS_RANGE}
            step={1}
            initialValue={
              orderReturnDetail.orderReturnStatus === ORDER_RETURN_STATUS.REFUND_DONE
                ? orderReturnDetail.refundActualAmount
                : orderReturnDetail.refundSellerAmount
            }
            onChange={(value) => onChangeRefundActualAmount(value)}
            addonAfter="원"
            name="orderReturnDetail.refundActualAmount"
          />

          {/*책정 사유*/}
          <TextAreaForm
            className="refund-complete-reason"
            form={form}
            label="책정 사유"
            isEditable={orderReturnDetail.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE}
            initialValue={orderReturnDetail.refundCompleteReason}
            maxLength={MAXIMUM_NUMBER_OF_ORDER_RETURN_REFUND_COMPLETE_REASON_TEXT}
            rules={[formRequiredRules(true, '최종 환불 금액에 대한 간략하게 사유를 남겨주세요.')]}
            onChange={(value) =>
              setData({
                path: ['orderReturnDetail', 'refundCompleteReason'],
                value,
              })
            }
            name="orderReturnDetail.refundCompleteReason"
            rows={6}
            subContent={
              <div className="sub-info">
                <div>* 추가 청구 비용에 대한 내용 또는 구매자와 상의한 내용을 적어주세요.</div>
                <div>* 작성하신 내용은 구매자에게 보여집니다.(아몬즈 앱에 노출)</div>
              </div>
            }
          />

          {/*관리자 메모*/}
          <TextAreaForm
            form={form}
            label="관리자 메모"
            isEditable={orderReturnDetail.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE}
            initialValue={orderReturnDetail.adminMemo}
            maxLength={MAXIMUM_NUMBER_OF_ORDER_RETURN_ADMIN_MEMO_TEXT}
            rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
            onChange={(value) =>
              setData({
                path: ['orderReturnDetail', 'adminMemo'],
                value,
              })
            }
            name="orderReturnDetail.adminMemo"
            rows={6}
          />

          {/*반품 완료한 관리자*/}
          <BaseForm label="반품 완료한 관리자" content={setDash(orderReturnDetail.adminName)} />

          {/*구매자의 결제 수단*/}
          <BaseForm label="구매자의 결제 수단" content={PAY_METHOD_TYPE_TEXT[orderReturnDetail.payMethod]} />

          {/*구매자의 결제 수단이 가상계좌일 때만 환불받을 계좌번호를 보여준다.*/}
          {/*구매자가 환불받을 계좌정보*/}
          {orderReturnDetail.payMethod === PAY_METHOD_TYPE.VBANK ? (
            <BaseForm
              label="구매자가 환불받을 계좌정보"
              content={
                <div className="refund-account-info">
                  <span>{orderReturnDetail.bankName}</span>
                  <span>{orderReturnDetail.bankNumber}</span>
                  <span>{orderReturnDetail.bankHolder}</span>
                </div>
              }
              subContent={
                <div className="sub-info">
                  <div>구매자의 결제 수단이 가상계좌일 때,</div>
                  <div>반품 요청 시 입력된 환불계좌정보로 환불이 됩니다.</div>
                </div>
              }
            />
          ) : null}
        </div>
      </Panel>

      {/*관리자가 계산한 판매자가 정산받을 예상 금액*/}
      <Panel>
        <div className="panel-header">
          <div className="title">판매자가 정산 받을 금액</div>
        </div>

        <div className="panel-body">
          {/*주문 결제 금액*/}
          <BaseForm label="주문 결제 금액" content={setNumberWithComma(orderReturnDetail.orderPaymentAmount, '원')} />

          {/*주문 결제 취소 금액*/}
          <BaseForm
            label="주문 결제 취소 금액"
            content={setNumberWithComma(orderReturnDetail.orderPaymentCancelAmount, '원')}
          />

          {/*고객 결제 금액*/}
          <BaseForm label="고객 결제 금액" content={setNumberWithComma(orderReturnDetail.totalPrice, '원')} />

          {/*고객 부담 추가 배송비(도서산간)*/}
          <BaseForm
            label="고객 부담 추가 배송비(도서산간)"
            content={setNumberWithComma(orderReturnDetail.buyerDeliveryExtraFee, '원')}
          />

          {/*판매자 부담 추가 배송비(도서산간)*/}
          <BaseForm
            label="판매자 부담 추가 배송비(도서산간)"
            content={setNumberWithComma(orderReturnDetail.sellerDeliveryExtraFee, '원')}
          />

          {/*최종 환불 금액*/}
          <BaseForm label="최종 환불 금액" content={setNumberWithComma(orderReturnDetail.refundActualAmount, '원')} />

          {/*판매자가 정산받을 금액*/}
          <BaseForm
            className="emphasize"
            label="판매자가 정산받을 금액"
            content={setNumberWithComma(orderReturnDetail.sellerExpectBalanceAmount, '원')}
            subContent={
              <div className="sub-price-info">
                <div>[고객 결제 금액 + 고객 부담 추가 배송비 - 최종 환불 금액]</div>
              </div>
            }
          />
        </div>
      </Panel>
    </div>
  );
};

export default OrderReturnDetail;
